import { OrderOption, OrderingOption } from 'kiolyn-api';

export default function newOrderOption(option: OrderingOption): OrderOption {
  return {
    id: option.id,
    type: 'order-option',
    name: option.name || '',
    name2: option.name2 || '',
    price: option.price || 0,
    subtotal: 0,
    count: 1,
    suboptions: [],
    required_level: option.required_level || ''
  };
}
